import actionTypes from './actionTypes';

const requestTeams = () => ({
    type: actionTypes.REQUEST_TEAMS
});

const teamsResponse = (success, teams, error, season = 'active') => ({
    type: actionTypes.TEAMS_RESPONSE,
    payload: {
        success,
        teams,
        season,
        errors: error
    }
});

const requestGamesForTeam = () => ({
    type: actionTypes.REQUEST_GAMES_FOR_TEAM
});

const gamesForTeamResponse = (success, team, error) => ({
    type: actionTypes.GAMES_FOR_TEAM_RESPONSE,
    payload: {
        success,
        team,
        errors: error
    }
});

const requestLogoAssets = () => ({
    type: actionTypes.REQUEST_LOGO_ASSETS
});

const logoAssetsResponse = (success, logos, error) => ({
    type: actionTypes.LOGO_ASSETS_RESPONSE,
    payload: {
        success,
        logos,
        errors: error
    }
});

const requestTeamSocialAccounts = () => ({
    type: actionTypes.REQUEST_TEAM_SOCIAL_ACCOUNTS
});

const teamSocialAccountsResponse = (success, accounts, error) => ({
    type: actionTypes.TEAM_SOCIAL_ACCOUNTS_RESPONSE,
    payload: {
        success,
        accounts,
        errors: error
    }
});

const requestGameNotes = () => ({
    type: actionTypes.REQUEST_GAME_NOTES
});

const gameNotesResponse = (success, teamId, gameNotes, errors) => ({
    type: actionTypes.GAME_NOTES_RESPONSE,
    payload: {
        success,
        teamId,
        gameNotes,
        errors
    }
});

export default {
    requestTeams,
    teamsResponse,
    requestGamesForTeam,
    gamesForTeamResponse,
    requestLogoAssets,
    logoAssetsResponse,
    requestTeamSocialAccounts,
    teamSocialAccountsResponse,
    requestGameNotes,
    gameNotesResponse
};